import { apiClient } from '../utils/apiClient';

/**
 * Read-only client for the Booreq extension marketplace (`/api/v1/extensions`).
 * Public, unauthenticated endpoints — any failure (offline, 5xx, parse error)
 * is the caller's responsibility to treat as "no update available", never a
 * hard error that should block registering the bundled fallback.
 */
export async function listPublished() {
  const res = await apiClient.get('/extensions');
  return res.data.extensions || [];
}

export async function getBySlug(slug) {
  const res = await apiClient.get(`/extensions/${encodeURIComponent(slug)}`);
  return res.data;
}
